import { getUserCertificates, isValidSystemSetup } from 'crypto-pro';

export const checkUserSystem = async () => {
  try {
    if (await isValidSystemSetup()) return true;
  } catch (e) {
    return false;
  }
  return false;
};

export const checkSertificate = async () => {
  try {
    getUserCertificates()
      .then((res) => !res)
      .finally(() => false);
    return false;
  } catch (e) {
    return false;
  }
};
